export default {
      id: "attention-thin-solid-usage",
      viewBox: "0 0 18 17",
      url: __webpack_public_path__ + "sprite-46b249.svg#attention-thin-solid-usage",
      toString: function () {
        return this.url;
      }
    }